module.exports = __webpack_public_path__ + "static/crop-b5e914816aabcd3b33a099bd2c3bea52.mp4";